"use client";

import { baseUrl } from "@/utils/api-definition";
import { t } from "@lingui/core/macro";
import Image from "next/image";
import Box from "@mui/material/Box";

export default function GiftBanner() {
  return (
    <div className="mb-2.5 mt-8 flex w-full justify-center text-sm">
      <Box
        sx={{
          maxWidth: "599px",
          maxHeight: "556px",
          width: { xs: "100%", sm: "90%", md: "100%", lg: "100%" },
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Image
          loading="lazy"
          src={`${baseUrl}` + "/image/gift_images/gift_page/gift-page.png"}
          width={600}
          height={600}
          alt={t`Design and give away vouchers yourself`}
          style={{
            objectFit: "contain",
            width: "100%",
            height: "100%",
          }}
        />
      </Box>
    </div>
  );
}
